/**
 *
 * Points
 *
 */

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import TrackerButton from '@/components/TrackerButton.vue';
//import Header from '@/components/SharedHeader.vue';
import Footer from '@/components/Footer.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PointsGoodsModal from '@/views/Points/components/PointsGoodsModal.vue';
import PaypalSubmitting from '@/views/Points/components/PaypalSubmitting.vue';
import PointsChanges from '@/views/Points/components/PointsChanges.vue';
import PointsLog from '@/views/Points/components/PointsLog.vue';
//import { DEFAULT_DATA_URL } from '@/constants/index';
//import { POINTS_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from './Points.constants';

const GetMyPointsMixin = {
  name: 'GetMyPointsMixin',

  computed: {
    ...mapGetters('Points', {
      mg_mypoints: 'mypoints',
    }),
  },

  methods: {
    ...mapActions('Points', {
      ma_getMyPoints: 'getMyPoints',
    }),
  },

  created() {
    this.ma_getMyPoints();
  },
};

const PaypalInfoMixin = {
  name: 'PaypalInfoMixin',

  data: () => {
    return {
      promiseGetPointsPaypalInfo: null,
    };
  },

  methods: {
    ...mapMutations('Points', {
      mm_SET_PAY_STEP: 'SET_PAY_STEP',
    }),

    ...mapActions('Points', {
      ma_getPointsPaypalInfo: 'getPointsPaypalInfo',
    }),

    getPointsPaypalInfo() {
      this.promiseGetPointsPaypalInfo = this.ma_getPointsPaypalInfo({
        token: this.$route.query.token,
        PayerID: this.$route.query.PayerID,
      });
    },

    PaypalMixinCreated() {
      if (this.$route.query.token) {
        if (this.$route.query.PayerID) {
          this.mm_SET_PAY_STEP('paypal');
          this.getPointsPaypalInfo();
        } else {
          this.mm_SET_PAY_STEP('paypal-fail');
        }
      }
    },

    async PaypalMixinMounted() {
      if (this.$route.query.token) {
        await this.promiseGetPointsPaypalInfo;
        this.$refs.PointsGoodsModal.show();
      }
    },
  },

  created() {
    this.PaypalMixinCreated();
  },

  mounted() {
    this.PaypalMixinMounted();
  },
};

export default {
  name: 'Points',

  mixins: [GetMyPointsMixin, PaypalInfoMixin],

  components: {
    //Header,
    Footer,
    //TabBar,
    WayFindBar,
    Aside,
    Spinner,
    TrackerButton,
    PointsGoodsModal,
    PaypalSubmitting,
    PointsChanges,
    PointsLog,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('Points', {
      ms_isPaypalSubmitting: 'isPaypalSubmitting',
      ms_isRequest: 'isRequest',
      ms_isRequestLong: 'isRequestLong',
    }),

    //...mapGetters({
    //  mg_userInfo: 'userInfo',
    //}),
  },
};
